// browser-based parsing of urls
// parseUrl :: String -> DOM Object
export const parseUrl = (_url) => {
  const url = document.createElement('a');
  url.href = _url;
  return url;
};

// noTrailingSlash :: String -> String
export const noTrailingSlash = (str) => str.replace(/\/$/, '');

// parseUrl uses the DOM/browser to sanitize urls, making these all more consistent
// stripSlash :: String -> String
export const stripSlash = (str = '') =>
  noTrailingSlash(parseUrl(String(str)).pathname);

export const slugify = (string) =>
  string
    ? String(string)
        .trim()
        .replace('amp;', '')
        .replace(/\s/g, '-') // turn spaces into slugs
        .replace(/[^\w-]+/g, '') // remove non-letters/dashes
        .replace(/-+/g, '-') // only one dash allowed
        .toLowerCase()
    : '';
